/* FND Mobile Nav — panel navigation + search overlay */
(function () {
  'use strict';

  var panelStack = ['main'];

  function getPanel(id) {
    return document.querySelector('.fnd-panel[data-panel="' + id + '"]');
  }

  function navigateTo(panelId) {
    var currentId = panelStack[panelStack.length - 1];
    var current = getPanel(currentId);
    var next = getPanel(panelId);
    if (!next || !current) return;
    current.classList.add('is-exit-left');
    current.classList.remove('is-active');
    next.classList.add('is-active');
    panelStack.push(panelId);
  }

  function navigateBack() {
    if (panelStack.length <= 1) return;
    var currentId = panelStack.pop();
    var prevId = panelStack[panelStack.length - 1];
    var current = getPanel(currentId);
    var prev = getPanel(prevId);
    if (!current || !prev) return;
    current.classList.remove('is-active');
    prev.classList.remove('is-exit-left');
    if (prevId !== 'main') prev.classList.add('is-active');
  }

  function resetPanels() {
    panelStack = ['main'];
    document.querySelectorAll('.fnd-panel').forEach(function (p) {
      p.classList.remove('is-active', 'is-exit-left');
    });
  }

  function closeDrawer() {
    var summary = document.querySelector('#Details-menu-drawer-container > summary');
    if (summary) summary.click();
    setTimeout(resetPanels, 350);
  }

  function initPanels() {
    document.querySelectorAll('.fnd-nav-trigger[data-target]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        navigateTo(this.dataset.target);
      });
    });

    document.querySelectorAll('.fnd-panel__back-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        navigateBack();
      });
    });

    document.querySelectorAll('.fnd-panel__close-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    });

    var details = document.querySelector('#Details-menu-drawer-container');
    if (details) {
      details.addEventListener('toggle', function () {
        if (!this.open) setTimeout(resetPanels, 350);
      });
    }
  }

  /* ── Mobile Search ── */
  function initSearch() {
    var overlay = document.getElementById('fnd-search-overlay');
    if (!overlay) return;

    var input = overlay.querySelector('.fnd-search-overlay__input');
    var cancelBtn = overlay.querySelector('.fnd-search-cancel');

    function openSearch() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 320);
    }

    function closeSearch() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (input) input.value = '';
    }

    /* Intercept Dawn's search details toggle on mobile */
    document.addEventListener('click', function (e) {
      if (window.innerWidth >= 990) return;
      var searchSummary = e.target.closest('.header__icon--search, .header__icon--summary');
      if (!searchSummary) return;
      var isSearchIcon = searchSummary.closest('details') &&
        !searchSummary.closest('#Details-menu-drawer-container');
      if (isSearchIcon) {
        e.preventDefault();
        e.stopPropagation();
        openSearch();
      }
    }, true);

    if (cancelBtn) cancelBtn.addEventListener('click', closeSearch);

    var form = overlay.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = input ? input.value.trim() : '';
        if (!q) return;
        window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
    });

    /* ── Mobile Predictive Search ── */
    var psBody        = overlay.querySelector('.fnd-search-overlay__body');
    var psPopularHTML = psBody ? psBody.innerHTML : '';
    var psTimer       = null;
    var psAbort       = null;

    function fmtMoney(cents) {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    }
    function escHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function(c){
        return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
      });
    }
    function hlText(text, q) {
      var safe = escHtml(text);
      var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g,'\\$&') + ')', 'gi');
      return safe.replace(re, '<mark>$1</mark>');
    }

    function showPopular() {
      if (psAbort) { psAbort.abort(); psAbort = null; }
      if (psBody) psBody.innerHTML = psPopularHTML;
    }

    function renderResults(q, products, queries) {
      if (!psBody) return;
      var searchUrl = '/search?q=' + encodeURIComponent(q) + '&type=product';
      var html = '';

      /* ── Suggerimenti query ── */
      if (queries && queries.length) {
        html += '<p class="fnd-ps-mob-section-label">Suggerimenti principali</p>';
        html += '<ul class="fnd-ps-mob-queries">';
        queries.forEach(function(s) {
          var text  = escHtml(s.text || '');
          /* typed part bold, rest normal */
          var re    = new RegExp('^(' + q.replace(/[.*+?^${}()|[\]\\]/g,'\\$&') + ')(.*)', 'i');
          var match = text.match(re);
          var label = match
            ? '<strong>' + match[1] + '</strong>' + match[2]
            : '<strong>' + text + '</strong>';
          html += '<li><a href="' + escHtml(s.url) + '" class="fnd-ps-mob-qrow">' + label + '</a></li>';
        });
        html += '</ul>';
      }

      /* ── Griglia prodotti ── */
      if (products.length === 0) {
        html += '<p class="fnd-ps-mob-empty">Nessun prodotto trovato per <strong>' + escHtml(q) + '</strong></p>';
      } else {
        var cards = products.map(function(p) {
          var img = p.featured_image && p.featured_image.url
            ? '<img src="' + p.featured_image.url + '&width=400" alt="' + escHtml(p.featured_image.alt || p.title) + '" width="400" height="400" loading="lazy">'
            : '<div class="fnd-ps-mob-card-noimg">✦</div>';
          var price   = fmtMoney(p.price);
          var compare = p.compare_at_price > p.price
            ? '<s class="fnd-ps-mob-card-compare">' + fmtMoney(p.compare_at_price) + '</s>' : '';
          return '<a href="' + p.url + '" class="fnd-ps-mob-card">' +
            '<div class="fnd-ps-mob-card-img">' + img + '</div>' +
            '<div class="fnd-ps-mob-card-body">' +
              '<p class="fnd-ps-mob-card-name">' + escHtml(p.title) + '</p>' +
              '<p class="fnd-ps-mob-card-price">' + price + compare + '</p>' +
            '</div>' +
          '</a>';
        }).join('');
        html += '<div class="fnd-ps-mob-grid">' + cards + '</div>';
      }

      html += '<a href="' + searchUrl + '" class="fnd-ps-mob-all">Vedi tutti i risultati per &ldquo;<strong>' + escHtml(q) + '</strong>&rdquo; ' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7h8M8 4l3 3-3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
      psBody.innerHTML = html;
    }

    function fetchPS(q) {
      if (psAbort) psAbort.abort();
      psAbort = new AbortController();
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query&resources[limit]=4&resources[options][unavailable_products]=last', { signal: psAbort.signal })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var res      = (data.resources && data.resources.results) || {};
          var products = res.products || [];
          var queries  = res.queries  || [];
          renderResults(q, products, queries);
        })
        .catch(function(err) { if (err.name !== 'AbortError') showPopular(); });
    }

    if (input) {
      input.addEventListener('input', function() {
        var q = this.value.trim();
        clearTimeout(psTimer);
        if (q.length < 2) { showPopular(); return; }
        psTimer = setTimeout(function() { fetchPS(q); }, 280);
      });
    }

    /* Reset popular on close */
    if (cancelBtn) {
      cancelBtn.addEventListener('click', showPopular);
    }
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) showPopular();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPanels();
      initSearch();
    });
  } else {
    initPanels();
    initSearch();
  }
})();
